<script>
  // Monospace code block matching the wf2 .wf2-code look.
  let { text = '', lang = null } = $props();
</script>

<pre class="wf2-code">{#if lang}<span class="wf2-code-lang">{lang}</span>{/if}{text}</pre>
